<script setup lang="ts">
import axios from 'axios'
import { Download, Loader2 } from 'lucide-vue-next'
import { Button } from '@/ui/button'

const props = withDefaults(
  defineProps<{
    isBatch?: boolean
    filename?: string | null
    path: string
    params?: Record<string, unknown>
    iconOnly?: boolean
  }>(),
  {
    isBatch: false,
    filename: null,
    params: () => ({}),
    iconOnly: false
  }
)

const { t } = useI18n()
const router = useRouter()
const notification = useNotification()

const inProgress = ref(false)

const downloadCsv = () => {
  if (props.isBatch) {
    batchProgrammed()
  } else {
    if (inProgress.value) return
    inProgress.value = true
    instantDownload()
  }
}

const instantDownload = () => {
  axios
    .get(props.path, { responseType: 'blob', params: props.params })
    .then((response) => {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]))
      const fileLink = document.createElement('a')
      fileLink.href = fileURL
      if (props.filename) fileLink.setAttribute('download', props.filename)
      document.body.appendChild(fileLink)
      fileLink.click()
      notification.create('success', { text: t('global.download.success'), timeout: 2000 })
      inProgress.value = false
    })
    .catch(() => {
      notification.create('error', { text: t('global.download.error') })
      inProgress.value = false
    })
}

const batchProgrammed = () => {
  axios
    .get(props.path, { params: props.params })
    .then(() => {
      notification.create('success', { text: t('global.download.batch.success') })
      router.push({ name: 'ExportList' })
    })
    .catch(() => {
      notification.create('error', { text: t('global.download.error') })
    })
}
</script>

<template>
  <AppTooltip v-if="iconOnly" :text="t('pages.customer.customerPage.export.button')">
    <Button variant="outline" size="icon" :disabled="inProgress" @click="downloadCsv">
      <Loader2 v-if="inProgress" class="h-4 w-4 animate-spin" />
      <Download v-else class="h-4 w-4" />
    </Button>
  </AppTooltip>
  <Button v-else variant="outline" :disabled="inProgress" @click="downloadCsv">
    <Loader2 v-if="inProgress" class="h-4 w-4 animate-spin" />
    <Download v-else class="h-4 w-4" />
    {{ t('pages.customer.customerPage.export.button') }}
  </Button>
</template>
